import { SLINKY } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const PreviewCardReplyForwardIndicator = styled(UIIcon).withConfig({
  displayName: "ResponseStatusIcon__PreviewCardReplyForwardIndicator",
  componentId: "sc-1cmc0ka-0"
})(["margin-right:6px;color:", ";"], SLINKY);
const ResponseStatusIcon = ({
  forwarded,
  repliedTo
}) => {
  const icon = forwarded ? 'forward' : repliedTo ? 'reply' : null;
  return icon && /*#__PURE__*/_jsx(PreviewCardReplyForwardIndicator, {
    name: icon,
    size: 'xxs'
  });
};
ResponseStatusIcon.displayName = 'ResponseStatusIcon';
export default ResponseStatusIcon;